// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__cMXfP","tab":"ProcedureTabs_tab__1BEUI"};